export const safeStringify = (value: unknown): string =>
	JSON.stringify(value).replace(/</g, "\\u003c");
